const DRAWER_WIDTH = "240px";
const ODD_OPACITY = 0.8;
const ERROR_MESSAGE = "Something went wrong! Please try again later";

export { DRAWER_WIDTH, ODD_OPACITY, ERROR_MESSAGE };
